import { useState, useEffect } from 'react';
// Import Store
import { useAppSelector } from 'store';
import { selectHeaderTimeFormat } from 'store/slices/header';
import { selectUserActivePartnerTimeZone } from 'store/slices/userData';
// Import UI components
import { Tooltip } from '@geneui/components';
// Import constants
import { TimeZonePack } from 'constants/common';
// Import Services
import { Helpers } from 'services';

const { customMoment } = Helpers;

const UserTime = () => {
    const timeFormat = useAppSelector(selectHeaderTimeFormat);
    const ActivePartnerTimeZone = useAppSelector(selectUserActivePartnerTimeZone) ?? 0;
    const [time, setTime] = useState(customMoment().format(timeFormat));

    useEffect(() => {
        const clearIntervalToken = setInterval(() => setTime(customMoment().format(timeFormat)), 1000);
        return () => clearInterval(clearIntervalToken);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Tooltip style={{ marginTop: '11px' }} text={TimeZonePack[ActivePartnerTimeZone]} position="bottom">
            <p>{time}</p>
        </Tooltip>
    );
};

export default UserTime;
